(function () {
    if (!window.location.pathname.includes('/store-locator')) return;
  
    const FIXES = {
      fixSearchboxRole(input) {
        if (input.getAttribute('role') === 'searchbox') {
          input.removeAttribute('role');
          console.log('[ADA FIX] Removed role="searchbox" from input');
        }
      },
  
      fixInvalidAriaRoleDescription(el) {
        if (el.hasAttribute('aria-roledescription')) {
          const desc = el.getAttribute('aria-roledescription');
          if (!el.hasAttribute('aria-label')) {
            el.setAttribute('aria-label', desc === 'map' ? 'Store location map' : desc);
          }
          el.removeAttribute('aria-roledescription');
          console.log('[ADA FIX] Removed aria-roledescription and added aria-label');
        }
      },
  
      fixPreviewBarIframe() {
        const iframe = document.getElementById('PBarNextFrame');
        if (iframe) {
          // Set title (or "" if decorative)
          if (!iframe.hasAttribute('title')) {
            iframe.setAttribute('title', '');
          }
      
          // Remove invalid role and hide from screen readers
          iframe.removeAttribute('role');
          iframe.setAttribute('aria-hidden', 'true');
      
          console.log('[ADA FIX] Updated preview iframe with valid attributes');
        }
      }
      
    };
  
    // Observe changes for Storemapper fixes
    const observer = new MutationObserver(() => {
      document.querySelectorAll('input[role="searchbox"]').forEach(FIXES.fixSearchboxRole);
      document.querySelectorAll('[aria-roledescription]').forEach(FIXES.fixInvalidAriaRoleDescription);
    });
  
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  
    // Also fix once after delay
    setTimeout(() => {
      document.querySelectorAll('input[role="searchbox"]').forEach(FIXES.fixSearchboxRole);
      document.querySelectorAll('[aria-roledescription]').forEach(FIXES.fixInvalidAriaRoleDescription);
      FIXES.fixPreviewBarIframe();
    }, 1000);
  
    // Observe for the preview bar iframe
    const iframeObserver = new MutationObserver(() => {
      const iframe = document.getElementById('PBarNextFrame');
      if (iframe) FIXES.fixPreviewBarIframe();
    });
  
    iframeObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  })();
  